// Currently deprioritized
// Shows history of application when you click into it on the Application Tracker page

import React, { useContext } from 'react';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';
import TableRow from './TableRow'; // Import TableRow component

const ApplicationDetails = () => {
  // Change component name to ApplicationDetails
  const { selectedApp, setAppDetailsOpen } = useContext(ApplicationTrackerContext); // Destructure currentApps from GlobalContext

  return (
    <div>
      <div
        id="hs-basic-modal"
        className={`hs-overlay flex justify-center items-center hs-overlay-open:opacity-100 hs-overlay-open:duration-500 bg-black/70 size-full fixed top-0 inset-s-0 z-80 transition-all pointer-events-none`}
      >
        <div className="w-auto h-auto m-3 sm:mx-auto bg-white border shadow-xs rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/70">
          {' '}
          <div className="flex flex-col bg-white border shadow-xs rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/70">
            <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
              <h3 className="font-bold text-gray-800 dark:text-white">
                {selectedApp.companyName} application history
              </h3>
              <button
                type="button"
                onClick={() => setAppDetailsOpen((prev) => !prev)}
                className="flex justify-center items-center size-7 text-base font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700"
                data-hs-overlay="#hs-basic-modal"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18"></path>
                  <path d="m6 6 12 12"></path>
                </svg>
              </button>
            </div>
            <div className="p-4 overflow-y-auto">
              {selectedApp.history.map((item) => (
                <TableRow
                  isHistory={true}
                  key={item.id}
                  date={item.date ? new Date(item.date).toLocaleDateString() : ''}
                  company={item.companyName}
                  status={item.status}
                  position={item.position}
                />
              ))}
            </div>
            <div className="flex justify-center items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
              <button
                type="button"
                className="py-2 px-3 inline-flex items-center gap-x-2 text-base font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
              >
                Add application update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationDetails;
